import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useLocationQueryParams from './useLocationQueryParams';
import { setSelectedDepot } from '../store/reducers/app';
import { getUserDepots } from '../store/selectors/user';
import { getDepotByCode } from '../models/depot';
import usePrevious from './usePrevious';
import { wrapPromise } from '../utils/promise';
import { ENVIRONMENT_MODE } from '../constants/app';
import { clearRouteFilters } from '../store/reducers/ui/filterPanel';

const useDepotChangeListener = (warningModalRef) => {
  const dispatch = useDispatch();
  const { depot } = useLocationQueryParams();
  const prevDepot = usePrevious(depot);
  const userDepots = useSelector(getUserDepots);

  const redirectToNewEnv = useCallback(
    (redirectUrl) => {
      window.location.href = `https://${redirectUrl}/${window.location.pathname}?depot=${depot}`;
    },
    [depot]
  );

  const showRedirectModal = useCallback(
    async (redirectUrl) => {
      await wrapPromise(warningModalRef.current.showModal());
      redirectToNewEnv(redirectUrl);
    },
    [warningModalRef, redirectToNewEnv]
  );

  useEffect(() => {
    const depotData = getDepotByCode(userDepots, depot);
    if (
      !import.meta.env.DEV &&
      depotData &&
      depotData.operatingEnvironmentHost &&
      depotData.operatingEnvironmentHost !== window.location.hostname
    ) {
      const redirectUrl = depotData.operatingEnvironmentHost;
      depotData.environmentMode === ENVIRONMENT_MODE.DISASTER_RECOVERY
        ? showRedirectModal(redirectUrl)
        : redirectToNewEnv(redirectUrl);
    }
    if (prevDepot !== depot) {
      dispatch(setSelectedDepot(depot));
      dispatch(clearRouteFilters());
    }
  }, [
    depot,
    dispatch,
    prevDepot,
    redirectToNewEnv,
    showRedirectModal,
    userDepots,
  ]);
};

export default useDepotChangeListener;
